import { Button } from '@newcore/ui/buttons';
import { Card } from '@newcore/ui/card';
import { FontWeights } from '@newcore/ui/enums/font-weights';
import { TextSizes } from '@newcore/ui/enums/typography-text-sizes';
import { ButtonVariants } from '@newcore/ui/enums/variants';
import { Text } from '@newcore/ui/typography';
import { EXAMPLE_SERVERS } from '../constants/example-servers';
import { IMPLEMENTATION_GUIDES } from '../constants/mcp-tester-content';
import { DocLinks } from './doc-links';

interface McpTesterEmptyStateProps {
  onPick: (url: string) => void;
}

export function McpTesterEmptyState({ onPick }: McpTesterEmptyStateProps) {
  return (
    <div className='flex flex-col gap-6'>
      <Card className='p-4'>
        <Text as='p' weight={FontWeights.SEMIBOLD} className='text-primary'>
          Try one of these
        </Text>
        <Text as='p' className='text-tertiary'>
          Public MCP servers that each hand out clients a different way.
        </Text>
        <div className='flex flex-col gap-2 pt-3'>
          {EXAMPLE_SERVERS.map(example => (
            <Button
              key={example.url}
              type='button'
              variant={ButtonVariants.SECONDARY}
              onClick={() => onPick(example.url)}
              className='h-auto w-full justify-start whitespace-normal px-3 py-2 text-left'
              data-testid={`mcp-tester-example-${example.label}`}
            >
              <div className='flex flex-col items-start gap-0.5'>
                <Text
                  as='p'
                  weight={FontWeights.MEDIUM}
                  className='text-primary'
                >
                  {example.label}
                </Text>
                <Text
                  as='p'
                  size={TextSizes.XS}
                  className='text-tertiary break-all font-mono'
                >
                  {example.url}
                </Text>
                <Text as='p' size={TextSizes.XS} className='text-tertiary'>
                  {example.expectation}
                </Text>
              </div>
            </Button>
          ))}
        </div>
      </Card>

      <Card className='p-4'>
        <Text as='p' weight={FontWeights.SEMIBOLD} className='text-primary'>
          Building a server?
        </Text>
        <Text as='p' className='text-tertiary'>
          MCP authorization is OAuth 2.1 plus two discovery documents. These
          cover the common server stacks.
        </Text>
        <DocLinks links={IMPLEMENTATION_GUIDES} />
      </Card>
    </div>
  );
}
